import { connect } from 'react-redux'
import { verifyPaymentStart } from './actions'

const hocConnect = (InnerComponent) => connect(null, { verifyPaymentStart })(InnerComponent)

export default hocConnect
